import {menuStore} from "./store";
import {mapState} from 'ui.vue3.pinia'

export const SegmentBodySale = {
    props: {
        itemSale: Object,
        ar1Item: Object,
    },
    emits: ['open'],
    computed: {
        ...mapState(menuStore, ['sales', 'isMobile']),
        cssClass() {
            return {
                open: this.itemSale.isShow
            }
        },
    },
    methods: {
        open(e) {
            if (this.isMobile) {
                e.preventDefault();
            }
            this.$emit('open');
            this.itemSale.isShow = true
        },
    },
    // language=Vue
    template: `
            <div class="header-nav-main-unit-body-section-segment" :class="cssClass">
                <a
                  class="header-nav-main-unit-body-section-segment-title"
                  @click="open($event)"
                  :class="{highlightMenu : itemSale.isShow}"
                  :href="itemSale.href"
                  v-html="itemSale.text"
                ></a>
                <div class="header-nav-main-unit-body-section-segment-body">
                    <div v-for="(arSale, key) in sales" class="header-nav-main-unit-body-section-segment-body-sale">
                        <div v-if="arSale.interval_str" 
                             class="header-nav-main-unit-body-section-segment-body-sale-date">
                          {{arSale['interval_str']}}
                        </div>
                        <div class="header-nav-main-unit-body-section-segment-body-sale-title">
                          <a :href="arSale['detail_page_url']">{{arSale['name']}}</a>
                        </div>
                    </div>
                    <a class="header-nav-main-unit-body-section-all header-nav-main-unit-body-section-all_promo" :href="ar1Item.href">
                            Посмотреть все 
                    </a>
                </div>
            </div>
    `
}